import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home"
}
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = { for: "search" }
const _hoisted_4 = { class: "word-list" }
const _hoisted_5 = { class: "word-list__summary" }
const _hoisted_6 = { class: "word-list mt-0" }
const _hoisted_7 = { class: "button-group" }
const _hoisted_8 = {
  key: 1,
  class: "home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WordListItem = _resolveComponent("WordListItem")!
  const _component_GlobalSearch = _resolveComponent("GlobalSearch")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _directive_touch = _resolveDirective("touch")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["filters__actions", {'is-selecting': _ctx.isSelecting}])
          }, [
            (_ctx.isSelecting)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-light no-outline filters__select btn-small",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelections && _ctx.toggleSelections(...args)))
                }, _toDisplayString(_ctx.isSelecting ? _ctx.t('cancel') : _ctx.t('select')), 1))
              : _createCommentVNode("", true),
            (_ctx.isSelecting)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-danger no-outline filters__select btn-small",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.isDeleteModalOpened = true)
                }, _toDisplayString(_ctx.t('delete')), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("label", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "search",
              name: "search",
              class: "search",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query) = $event))
            }, null, 512), [
              [_vModelText, _ctx.query]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.query ?
            `${_ctx.displayedWords.length} Word(s) Found` : `${_ctx.words.length} Words Total`), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedWords, (word, idx) => {
            return _withDirectives((_openBlock(), _createBlock(_component_WordListItem, {
              key: word.id,
              onClick: ($event: any) => (_ctx.wordClickHandler(idx)),
              onKeydown: ($event: any) => (_ctx.wordClickHandler(idx)),
              "is-selecting": _ctx.isSelecting,
              word: word
            }, null, 8, ["onClick", "onKeydown", "is-selecting", "word"])), [
              [_directive_touch, _ctx.toggleSelections, "hold"]
            ])
          }), 128)),
          (_ctx.ShowGlobalSearch)
            ? (_openBlock(), _createBlock(_component_GlobalSearch, {
                key: 0,
                query: _ctx.query,
                wordbook: _ctx.wordMap,
                onWordbookUpdated: _ctx.onWordbookUpdate
              }, null, 8, ["query", "wordbook", "onWordbookUpdated"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_FontAwesomeIcon, {
          class: "add-word",
          onClick: _ctx.addWord,
          icon: _ctx.faPlusCircle
        }, null, 8, ["onClick", "icon"]),
        (_ctx.isDeleteModalOpened)
          ? (_openBlock(), _createBlock(_component_Modal, {
              key: 0,
              onModalClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDeleteModalOpened = false)),
              onModalCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDeleteModalOpened = false)),
              onSubmit: _ctx.deleteSelected
            }, {
              header: _withCtx(() => [
                _createElementVNode("h2", null, "Are you sure you want to delete " + _toDisplayString(_ctx.words.filter((w) => w.selected).length > 1 ? 'these words' : 'this word') + "? ", 1)
              ]),
              content: _withCtx(() => [
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words.filter((w) => w.selected), (word) => {
                    return (_openBlock(), _createBlock(_component_WordListItem, {
                      key: word.id,
                      "is-selecting": false,
                      word: word
                    }, null, 8, ["word"]))
                  }), 128))
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn no-outline btn-medium btn-light",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDeleteModalOpened = false))
                  }, "Cancel "),
                  _createElementVNode("button", {
                    class: "btn no-outline btn-medium btn-danger",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)))
                  }, "Yes, Delete ")
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createVNode(_component_Spinner, { text: "Loading..." })
      ]))
}